import {Logic} from './Type'
import {Fantasy} from './Index'
import {Login} from './Login'
// import {S} from './Search'
// import {M} from './Modal'

export class Main extends Logic.Type {
    
    static Instance = new Main(new class {

        Update(state: Main): void {
            Main.Instance = state
        }
    })
    // default_language: number
    Location: string
    Login = Logic.Type.Add(this, new Login)
    Fantasy = Logic.Type.Add(this, new Fantasy)
    // S = Logic.Type.Add(this, new S)
    // M = Logic.Type.Add(this, new M)
}


// WEBPACK FOOTER //
// ./src/Logic/Main.ts